import apiClient from "@/api/client";
import type {
  Backup,
  BackupCreatePayload,
  RestorePayload,
  RetentionPolicy,
} from "@/types";

export async function getBackups(tenantId?: number | string): Promise<Backup[]> {
  const params = tenantId ? { tenant_id: tenantId } : {};
  const { data } = await apiClient.get<Backup[]>("/backups", { params });
  return data;
}

export async function getVMBackups(vmId: number): Promise<Backup[]> {
  const { data } = await apiClient.get<Backup[]>(`/backups/vm/${vmId}`);
  return data;
}

export async function createBackup(
  payload: BackupCreatePayload
): Promise<Backup> {
  const { data } = await apiClient.post<Backup>("/backups", payload);
  return data;
}

export async function restoreBackup(
  backupId: number,
  payload: RestorePayload
): Promise<{ task_id: string }> {
  const { data } = await apiClient.post<{ task_id: string }>(
    `/backups/${backupId}/restore`,
    payload
  );
  return data;
}

export async function getRetentionPolicies(
  tenantId: number | string
): Promise<RetentionPolicy[]> {
  const { data } = await apiClient.get<RetentionPolicy[]>(
    `/tenants/${tenantId}/retention-policies`
  );
  return data;
}

export async function updateRetentionPolicy(
  tenantId: number | string,
  policy: Partial<RetentionPolicy>
): Promise<RetentionPolicy> {
  const { data } = await apiClient.put<RetentionPolicy>(
    `/tenants/${tenantId}/retention-policies`,
    policy
  );
  return data;
}
